import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./forget-password.css";
import Footer from "../footer/footer.js";
import { Link } from "react-router-dom";
import axios from "axios";
import { handleError, handleSuccess } from "../../utils.js";
import logo from "../../assets/wjcw_logo.png";
import http from "../../core/service/http.js";
import Header from "../header/header.js";


export const useForgetPasswordHook = () => {

    const validationSchema = Yup.object({
        email: Yup.string()
          .email("Invalid email address")
          .required("Email is required"),
      });
    
      const handleSubmit = async (values, { setSubmitting, setErrors, resetForm }) => {
        try {
          // Sending a POST request with axios
          const response = await http.post("/v1/auth/forgot-password", {
            email: values.email,
          });
    
          handleSuccess("Password reset link has been sent to your email.");
          resetForm(); // Clear the form
        } catch (error) {
          console.error("Error sending reset email:", error);
          if (error.response) {
            // Server responded with an error status
            handleError(error.response.data.message);
          } else {
            // No response or network error
            handleError("Network error. Please try again later.");
          }
        }
        setSubmitting(false);
      };

    return{
        validationSchema,
        handleSubmit
    };
}